import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CourseDescription from '../../../components/courseDescription';
import CourseSchedule from '../../../components/courseSchedule';
import ItemGrid from '../../../components/itemGrid';

export default function Page02({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<CourseDescription
				mt={true}
				title='INSTRUCTIONS'
				texts={[
					'Get warmed up: 5min Walk Treadmill~Stretches~Light Weight Movement',
					'Always start with light weights~Avoid injury~to loosen muscle groups and get blood flowing',
					'Put your mind in the Muscle',
					'Strict Form is always 1st',
					'30 sec - 1min Breaks between sets',
					'Explosive on the Positives',
					'Control the Negatives',
					'Last Set Give 110% till failure',
					'Focus!!',
				]}
			/>
			<CourseSchedule
				mt={true}
				days={[
					{
						name: 'Sunday',
						action: 'BACK',
					},
					{
						name: 'Monday',
						action: 'CHEST & BICEPS',
					},
					{
						name: 'Tuesday',
						action: 'REST OR CARDIO',
					},
					{
						name: 'Wednesday',
						action: 'SHOULDERS & TRICEPS',
					},
					{
						name: 'Thursday',
						action: 'CARDIO',
					},
					{
						name: 'Friday',
						action: 'LEGS',
					},
					{
						name: 'Saturday',
						action: 'REST',
					},
				]}
			/>
			<ItemGrid
				mt={true}
				title='Customize Your Workout Plan'
				rows={[
					['BACK', 'A: Back', 'B. Back', 'C. Back'],
					[
						'Hammer-Pulldowns',
						'Under-Hand Cable Pulldowns',
						'Wide-Grip Seated Cable Rows',
						'Single-ARM Dumbbell Rows',
					],
					[
						'Bent-Over Barbell Rows',
						'Dumbbell Pull-overs',
						'Seated Cable Row (Rope Handle)',
						'Doubles Arm Dumbbell Rows (Bent-Over)',
					],
					['', 'Pullover-Machine', 'Seated Cable Row ( Double D Handle)', 'Chest-Supported Dumbbell Row'],
				]}
			/>
			<ItemGrid
				mt={true}
				rows={[
					['Chest', 'A: Chest', 'B. Chest', 'C. Chest'],
					['Cable Flys', 'Standard Bench Press', 'Machine Incline Chest Press', 'Standard Chest Flys'],
					[
						'Standard Chest Press',
						'Decline Bench Press',
						'Machine Decline Chest Press',
						'Incline Chest Flys',
					],
					['', 'Incline Bench', 'Standard Machine Press', 'Decline Chest Flys'],
				]}
			/>
			<ItemGrid
				mt={true}
				rows={[
					['Biceps', 'A: Biceps', 'B. Biceps'],
					['Machine Bicep Curl', 'Spider Curls', 'Hammer Curls'],
					['', 'Concentration Curl', 'Standing Dumbbell Curls'],
					['', 'Seated Bicep Curls', 'EZ Curls'],
				]}
			/>
			<ItemGrid
				mt={true}
				rows={[
					['Front Delts', 'Rear Delts', 'Capps'],
					['Standing Dumbbell Shoulder Raises', 'Reverse Cable Crossover', 'Dumbell Raises'],
					['Front Raises', 'Cable Machine High Pull with Ropes', 'Bent-Over DB Lateral Raises'],
					['Seated DB Raises', '', 'Standing Lateral Raises'],
					['Seated Barbell Raises', '', 'Lateral Cable Raise'],
				]}
			/>
			<ItemGrid
				mt={true}
				rows={[
					['Outer Triceps', 'Inner Triceps'],
					['Cable Pulldowns', 'Close-Grip Bench'],
					['Tricep Kick Backs', 'Skull Crushers'],
					['Seated DB Raises', ''],
					['Seated Barbell Raises', ''],
				]}
			/>
			<ItemGrid
				mt={true}
				rows={[
					['Legs', 'Hamstrings', 'Quads'],
					['Squats', 'Hamstring Curls', 'Leg Extension'],
					['Leg Press', 'Stiff-Legged Deadlifts', ''],
					['Hack Squats', '', ''],
					['Goblet Squats', '', ''],
				]}
			/>

			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
